import useAsyncData from 'src/utils/useAsyncData';
import { getOrganizationsAPI } from 'src/serverApi/organizations';

const useOrganizations = () => {
  const [
    fetchOrganizations,
    wasOrganizationsFetched,
    isOrganizationsLoading,
    organizations,
    organizationsError,
  ] = useAsyncData(getOrganizationsAPI);

  return {
    fetchOrganizations,
    wasOrganizationsFetched,
    isOrganizationsLoading,
    organizations,
    organizationsError,
  };
};

export default useOrganizations;
